import { IRoute } from "shared/interface/types";
import { HouseholdOrderRoutes } from "./healthOrderRoute";
import { healthShelfPlanB2CRoutes } from "./shelfPlanRoute/B2CRoute";

export const HouseholdRoutes: IRoute[] = [...HouseholdOrderRoutes, ...healthShelfPlanB2CRoutes];
